import script from "./SalesWebsite.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesWebsite.vue?vue&type=script&setup=true&lang=js"

import "./SalesWebsite.vue?vue&type=style&index=0&id=7f8312a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f8312a8"]])

export default __exports__